export default{
    newsTwoTitle: 'SDB Hadirkan Toko Score, Layanan Penilaian Kredit Berbasis Digital',
    newsTwoTime: "Tanggal Publis",
    newsTwoRead:"Tampilan Halaman",
    newsTwoSource:"Sumber artikel:",
    newsTwoDetail:[
        // {
        //     h4:"Take Away"
        // },
        {
            p:'Jakarta - Perusahaan penyedia layanan innovative credit scoring (ICS), Semangat Digital Bangsa (SDB) telah resmi meluncurkan Toko Score, pada Rabu (23/6) lalu. Toko Score merupakan layanan SDB yang terafiliasi dengan Tokopedia."Layanan ICS berbasis digital ini diharapkan bisa mempermudah para mitra strategis di industri keuangan menilai dan menyediakan pinjaman ke lebih banyak masyarakat Indonesia, terutama mereka yang masih belum mendapatkan akses ke layanan ﬁnansial," ungkap Head of Business Development and Marketing Semangat Digital Bangsa, Evita Soetjoadi dalam keterangan tertulis, Jumat (25/6/2021).'
        },
        // {
        //     h4:"Main Body"
        // },
        {
            p:'Evita menjelaskan Toko Score memberikan penilaian kredit (credit score) dari calon peminjam kepada para mitra strategis, dalam hal ini lembaga jasa keuangan. Toko Score akan menganalisis proﬁl risiko calon peminjam berdasarkan aktivitas dan perilaku transaksi calon peminjam di platform e-commerce Tokopedia.'
        },
        {
            p:'Ia menerangkan pihaknya akan mengedepankan prinsip keamanan dan perlindungan data pribadi berdasarkan peraturan yang berlaku dalam melakukan penilaian kredit.'
        },
        {
            p:'"Sederet kemudahan akses terhadap layanan ICS berbasis digital ini juga dapat membantu para mitra strategis, dalam hal ini lembaga jasa keuangan, mengukur proﬁl risiko calon peminjam secara real time," jelasnya.'
        },
        {
            p:'Di sisi lain, kata Evita, penilaian Toko Score secara tidak langsung turut membantu para penjual mendapatkan permodalan dalam mengembangkan usahanya. Tak hanya itu, penilaian Toko Score juga membantu para pembeli dalam memperoleh akses keuangan lebih luas sehingga mempermudah dalam memenuhi kebutuhan sehari-hari.'
        },
        {
            p:'Ia menambahkan baik para pembeli maupun para penjual yang belum memiliki akses layanan ﬁnansial (unbanked) bisa mendapatkan akses pinjaman dari lembaga keuangan formal, seperti perbankan.'
        },
        {
            p:'Berdasarkan Data Kementerian Keuangan RI pada April 2021, ia menyebutkan bahwa 132 juta orang di Indonesia saat ini masih unbanked dan belum memiliki akses terhadap kredit maupun pembiayaan.'
        },
        {
            p:'"Ini menjadi peluang bagi SDB untuk memberdayakan akses layanan ﬁnansial, bahkan di tengah pandemi saat ini," tambah Evita.'
        },
        {
            p:'Evita mengungkap Toko Score juga telah tercatat dan diawasi di Otoritas Jasa Keuangan (OJK) sehingga para mitra strategis dapat menggunakan layanan ICS Toko Score secara aman.'
        },
        {
            p:'Ia pun menerangkan bahwa SDB telah menjadi anggota dari Asosiasi FinTech Indonesia (AFTECH) sebagai Asosiasi Penyelenggara Inovasi Keuangan Digital. Menurutnya, kolaborasi yang konsisten dilakukan bersama dalam Toko Score ditujukan untuk menggencarkan sosialisasi dan edukasi kepada lembaga jasa keuangan, terutama lembaga keuangan mikro, terkait pengetahuan dan teknologi ICS sebagai daya saing.'
        },
        {
            p:'"Sesuai misi SDB dalam memberdayakan akses ﬁnansial kepada semua orang melalui teknologi, kami akan terus berinovasi agar lebih banyak masyarakat bisa mendapatkan akses terhadap lembaga keuangan formal melalui berbagai pilihan produk yang inklusif dan terjangkau sehingga dapat berkontribusi terhadap pemulihan ekonomi negara yang saat ini terdampak pandemi," pungkasnya.'
        },
       
    ]
}